<template>
    <div style="dispaly: inline-block; vertical-align: middle">
        <span v-if="showDetail">{{label}}</span>
        <el-select v-else v-model="currentValue"
            :placeholder="placeholder"
            @change="onChange"
            :multiple="multiple"
            :multiple-limit="multipleLimit"
            :disabled="disabled"
            :clearable="clearable"
            :collapse-tags="collapseTags"
            :filterable="filterable"
            :no-match-text="noMatchText"
            :no-data-text="noDataText"
            :value-key="valueKey">
            <el-option v-for="item in dataSource" :key="item.id" :value="item.id" :label="item.label">
            </el-option>
        </el-select>
        
    </div>
</template>

<script>
import Select from './select.js'
export default {
    name: 'v-select',
    mixins: [Select],
    props: {
        valueKey: {
            type: String,
            default: 'value'
        }
    },
    methods: {
        onChange (e) {
            let index = this.dataSource.findIndex(item => item.id === e)
            this.$emit('change', e, this.dataSource[index] ? this.dataSource[index] : {})
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/select.vue